import { ethers } from 'ethers';

// TODO: add tests
const formatUnits: typeof ethers.utils.formatUnits = (value, unitName) => {
  const formattedValue = ethers.utils.formatUnits(value, unitName);

  const [integer, decimal] = formattedValue.split('.');

  if (!decimal || /^0+$/.test(decimal)) {
    return integer;
  }

  return formattedValue;
};

export default formatUnits;
